function searchObject(search, object) {
  let objectHash = Object.values(object).join(" ");
  let n = objectHash.search(search);
  if (n === -1) {
    return false;
  }
  return true;
}

export default searchObject;
